import React from 'react';
import {Button, Intent} from '@blueprintjs/core';
import {useQuery, useMutation} from '@apollo/react-hooks';
import {gql} from 'apollo-boost';

import ShareFilesDialog from 'dialogs/ShareFilesDialog';
import {useUIActions} from 'utils/ui-context';

const SHARE_FILES = gql`
  {
    viewerState @client {
      selectingFiles,
      selectedFiles {
        id,
      },
    }
  }
`;

const SET_SELECTING_FILES = gql`
  mutation($value: Boolean!) {
    setSelectingFiles(value: $value) @client
  }
`;

const ShareFilesBar = ({clientId, guideId}) => {
  ////
  // GraphQL
  //
  const {data: {viewerState: {selectedFiles, selectingFiles}}} = useQuery(SHARE_FILES);
  const [setSelectingFiles] = useMutation(SET_SELECTING_FILES);
  const {setDialog} = useUIActions();

  ////
  // Render
  //
  if (!selectingFiles) return false;

  return (
    <div className="share-files--bar">
      <div className="share-files--content">
        <div className="file-count">{selectedFiles.length} file(s) selected</div>
        <div className="spacer" />
        <Button
          icon="cross"
          intent={Intent.DANGER}
          text="Cancel"
          onClick={() => setSelectingFiles({variables: {value: false}})}
        />
        <Button
          icon="eye-open"
          text="View selected"
          onClick={() => setDialog(() => (
            <ShareFilesDialog clientId={clientId} guideId={guideId} />
          ))}
        />
        <Button
          icon="share"
          intent={Intent.PRIMARY}
          text="Share"
          onClick={() => setDialog(() => (
            <ShareFilesDialog share clientId={clientId} guideId={guideId} />
          ))}
        />
      </div>
    </div>
  );
};

export default ShareFilesBar;
